<script lang="ts" setup>
  import { usePDF } from '@/store/pdfStore'
  import { Button } from '@/components/ui/button'
  import { useThemeColor } from '@/composables/useThemeColor'
  import { computed } from 'vue'

  const form = usePDF()
  const themeColor = computed(() => useThemeColor().value)

  const props = defineProps({
    message: {
      type: String,
      required: true
    },
    onConfirm: {
      type: Function,
      required: true
    },
    onCancel: {
      type: Function,
      required: true
    },
    visible: {
      type: Boolean,
      required: false,
      default: true
    }
  })

  function cancel() {
    props.onCancel(false)
  }

  function confirm() {
    props.onConfirm(true)
  }
</script>

<template>
  <div
    v-if="form.showConfirmModal"
    class="fixed inset-0 z-40 bg-black bg-opacity-50"
    @click="cancel"
  ></div>
  <div
    v-if="form.showConfirmModal"
    class="fixed left-1/2 top-1/2 z-50 grid w-full max-w-lg -translate-x-1/2 -translate-y-1/2 gap-4 border
      bg-background p-6 shadow-lg duration-200"
    :class="{
      'animate-in': form.showConfirmModal,
      'animate-out': !form.showConfirmModal,
      'fade-out-0': !form.showConfirmModal,
      'fade-in-0': form.showConfirmModal,
      'zoom-out-95': !form.showConfirmModal,
      'zoom-in-95': form.showConfirmModal,
      'slide-out-to-left-1/2': !form.showConfirmModal,
      'slide-out-to-top-[48%]': !form.showConfirmModal,
      'slide-in-from-left-1/2': form.showConfirmModal,
      'slide-in-from-top-[48%]': form.showConfirmModal
    }"
    style="pointer-events: auto"
  >
    <div class="flex flex-col gap-y-2 text-center sm:text-left">
      <h2
        id="modal-title"
        class="text-lg font-semibold"
      >
        Dokument abschicken
      </h2>
      <p
        id="modal-description"
        class="text-sm text-muted-foreground"
      >
        {{ message }}
      </p>
    </div>
    <div class="flex justify-between">
      <button
        type="button"
        class="mt-2 inline-flex h-10 items-center justify-center whitespace-nowrap rounded-md border border-input
          bg-background px-4 py-2 text-sm font-medium ring-offset-background transition-colors hover:bg-accent
          hover:text-accent-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring
          focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 sm:mt-0"
        @click="cancel"
      >
        Abbrechen
      </button>
      <button
        type="button"
        class="inline-flex h-10 items-center justify-center whitespace-nowrap rounded-md px-4 py-2 text-sm
          font-medium text-primary-foreground ring-offset-background transition-colors hover:bg-primary/90
          focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2
          disabled:pointer-events-none disabled:opacity-50"
        :class="`bg-${themeColor}-600 hover:bg-${themeColor}-800`"
        data-cy="confirmModalSendBtn"
        @click="confirm"
      >
        Ja, abschicken
      </button>
    </div>
  </div>
</template>
